module.exports = __webpack_public_path__ + "static/img/user8.b719cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/user8.png
// module id = 6Jq/
// module chunks = 0